<template>
  <div>
    <swiper
      :options="{
        slidesPerView: 'auto',
        freeMode: true,
        initialSlide: tab - 1,
      }"
      class="swiper"
    >
      <swiper-slide :class="{ active: tab == 1 }">
        <div @click="$router.push({ name: 'MemberList' }).catch(() => {})">
          {{ $t("menu.membership.member") }}
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: tab == 2 }">
        <div @click="$router.push({ name: 'LockerView' }).catch(() => {})">
          {{ $t("menu.membership.locker_room") }}
        </div>
      </swiper-slide>
      <!-- <swiper-slide :class="{ active: tab == 3 }">
        <div @click="$router.push({ name: 'PointList' }).catch(() => {})">
          {{ $t("member.bucks_management") }}
        </div>
      </swiper-slide> -->
    </swiper>

    <ul class="nav nav-pills" id="pills-tab" role="tablist">
      <li class="nav-item col-4" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-1-tab"
          type="button"
          @click="$router.push({ name: 'MemberList' }).catch(() => {})"
          :class="{ active: $route.name === 'MemberList' }"
        >
          {{ $t("menu.membership.member") }}
        </button>
      </li>
      <li class="nav-item col-4" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-2-tab"
          type="button"
          @click="$router.push({ name: 'LockerView' }).catch(() => {})"
          :class="{ active: $route.name === 'LockerView' }"
        >
          {{ $t("menu.membership.locker_room") }}
        </button>
      </li>
      <!-- <li class="nav-item col-4" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-3-tab"
          type="button"
          @click="$router.push({ name: 'PointList' }).catch(() => {})"
          :class="{ active: $route.name === 'PointList' }"
        >
          {{ $t("member.bucks_management") }}
        </button>
      </li> -->
    </ul>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  name: "Tab",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      /*swiperOptions: {
        slidesPerView: 'auto',
        freeMode: true
      }*/
    };
  },
  computed: {
    tab: function () {
      if (this.$route.name === "MemberList") return 1;
      else if (this.$route.name === "LockerView") return 2;
      /* else if (this.$route.name === "PointList") return 3; */
      else return 0;
    },
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
};
</script>